import { FC, PropsWithChildren } from 'react'

import { form, hiddenButton } from './styles.css'

export const VirtualOTPForm: FC<PropsWithChildren> = ({ children }) => (
  <form className={form}>
    {children}

    {/* Hack for IOS's keyboard auto submission, Especially for LiquidAss-Safari revamp */}
    <button
      type="submit"
      className={hiddenButton}
      onClick={e => e.preventDefault()}
    />
  </form>
)

export default VirtualOTPForm
